import type { Announcement } from '../types'
import { members } from './members'

const aktivni = members.filter((m) => m.type === 'aktivni').map((m) => m.id)
const zGosti = members
  .filter((m) => m.type !== 'nekdanji')
  .map((m) => m.id)
const tenorji = members.filter((m) => m.voice === 'tenor' || m.voice === 'bariton').map((m) => m.id)

export const announcements: Announcement[] = [
  {
    id: 'a01',
    naslov: 'Generalka prestavljena s petka na soboto',
    besedilo:
      'Obveščamo vas, da je generalka pred božičnim koncertom prestavljena s petka, 18. decembra, na soboto, 19. decembra, ob 10.00 v cerkvi sv. Lovrenca.\n\nRazlog je zasedenost prostora. Prosimo, da si termin takoj zabeležite in prihod potrdite v aplikaciji. Kdor ne bo mogel priti, naj to sporoči najkasneje do srede.\n\nHvala za razumevanje.',
    prioriteta: 'sprememba',
    avtor: 'Judita Volčanšek',
    objavljeno: '2026-11-17T18:20:00',
    obcinstvoLabel: 'Vsi člani in gostje',
    prejemniki: zGosti,
    zahtevaPotrditev: true,
    prebrali: zGosti.slice(0, 26),
  },
  {
    id: 'a02',
    naslov: 'Božični koncert — pomembne informacije',
    besedilo:
      'Božični koncert bo v soboto, 19. decembra, ob 19.00 v cerkvi sv. Lovrenca v Brežicah.\n\nZbor je ob 18.00 pri stranskem vhodu, v koncertnih oblekah. Dame prosimo za dolge črne obleke in temno obutev, gospodje za temne obleke z metuljčkom.\n\nMape prinesite s seboj, tudi če program pojemo na pamet.',
    prioriteta: 'pomembno',
    avtor: 'Krištof Strnad',
    objavljeno: '2026-11-15T09:05:00',
    obcinstvoLabel: 'Vsi člani in gostje',
    prejemniki: zGosti,
    zahtevaPotrditev: true,
    prebrali: zGosti.slice(0, 34),
  },
  {
    id: 'a03',
    naslov: 'Sekcijska vaja za tenorje — 24. november',
    besedilo:
      'V torek, 24. novembra, ob 18.30 bo v Glasbeni šoli Brežice sekcijska vaja za oba tenorja.\n\nUtrjevali bomo linije v Mozartovem Requiemu. Vaja traja do 20.00.',
    prioriteta: 'obicajno',
    avtor: 'Krištof Strnad',
    objavljeno: '2026-11-14T20:10:00',
    obcinstvoLabel: '1. tenor, 2. tenor',
    prejemniki: tenorji,
    zahtevaPotrditev: false,
    prebrali: tenorji.slice(0, 5),
  },
  {
    id: 'a04',
    naslov: 'Članarina 2026 je poravnana za vse člane',
    besedilo:
      'Zahvaljujemo se vsem članom — članarina za leto 2026 je poravnana v celoti.\n\nPoloženice za leto 2027 boste prejeli januarja. Znesek ostaja nespremenjen, 60 € letno.',
    prioriteta: 'obicajno',
    avtor: 'Barbara Ganzitti Siter',
    objavljeno: '2026-11-08T12:00:00',
    obcinstvoLabel: 'Vsi aktivni člani',
    prejemniki: aktivni,
    zahtevaPotrditev: false,
    prebrali: aktivni.slice(0, 31),
  },
  {
    id: 'a05',
    naslov: 'Nova gradiva na Google Drive',
    besedilo:
      'Na skupni Google Drive mapi so naložene nove note in vadbeni posnetki po glasovih za Mozartov Requiem.\n\nDostop imajo vsi člani z zborovskim e-naslovom. Če dostopa nimate, pišite tajnici.',
    prioriteta: 'obicajno',
    avtor: 'Dejan Jerončič',
    objavljeno: '2026-10-28T17:45:00',
    obcinstvoLabel: 'Vsi člani in gostje',
    prejemniki: zGosti,
    zahtevaPotrditev: false,
    prebrali: zGosti.slice(0, 38),
  },
]
